import axios from 'axios';

import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { CLIENT_PRODUCTS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_enable_product = (data) => {
    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };


            return axios.put(`${Config.API_BASE_URL}/ClientWhatIf/${session.idToken.payload["custom:clientId"]}/${data.productId}/enableDisable/${data.enableDisable}`, data, config)
                .then(response => {
                    dispatch({
                        type: CLIENT_PRODUCTS_GET,
                        payload: {
                            products: [
                                ...response.data,
                            ],
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    });
                })
                .catch(error => {
                    throw (error);
                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_enable_product;
